import { useState } from "react";
import { Play } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Motion";

export default function VideoFeature({ testid, overline, title, sub, src, poster, posterAlt, badge }) {
  const [playing, setPlaying] = useState(false);
  return (
    <section
      data-testid={testid}
      className="mx-auto max-w-7xl px-6 py-24 sm:px-10 sm:py-32 lg:px-16"
    >
      <SectionHead overline={overline} title={title} sub={sub} />
      <Reveal delay={0.15} className="mt-14">
        <div
          data-testid={`${testid}-frame`}
          className="relative mx-auto max-w-4xl overflow-hidden rounded-[2rem] border border-[#154234]/10 shadow-2xl"
        >
          {playing ? (
            <video
              src={src}
              poster={poster}
              controls
              autoPlay
              playsInline
              preload="auto"
              ref={(el) => {
                if (el) el.play().catch(() => {});
              }}
              data-testid={`${testid}-player`}
              className="aspect-video w-full bg-black"
            />
          ) : (
            <button
              onClick={() => setPlaying(true)}
              data-testid={`${testid}-play-button`}
              aria-label={`Play video: ${title}`}
              className="group relative block w-full cursor-pointer"
            >
              <img
                src={poster}
                alt={posterAlt}
                loading="lazy"
                decoding="async"
                className="aspect-video w-full object-cover"
              />
              <span className="absolute inset-0 bg-[#0B2B22]/30 transition-colors duration-300 group-hover:bg-[#0B2B22]/20" />
              <span className="absolute inset-0 grid place-items-center">
                <span className="grid size-20 place-items-center rounded-full bg-[#E05A47] text-white shadow-2xl transition-transform duration-300 group-hover:scale-110 sm:size-24">
                  <Play size={30} className="ml-1.5" fill="currentColor" />
                </span>
              </span>
              <span className="absolute bottom-5 left-6 font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-white/85 sm:text-xs">
                {badge}
              </span>
            </button>
          )}
        </div>
      </Reveal>
    </section>
  );
}
